import toast from "react-hot-toast";
import { privateRequest } from "../axios";

const ENDPOINT = {
    FREE_FORM: '/free-form-set',
   
};

export const fetchFreeFormAPI = async (
    pageNo: number = 1,
    perPage: number = 10,
    search: string = "",
    difficultyLevel: string = ""
) => {
    try {
        let url = `${ENDPOINT.FREE_FORM}?pageNo=${pageNo}&perPage=${perPage}&search=${search}`;
        if (difficultyLevel) {
            url += `&difficultyLevel=${difficultyLevel}`;
        }
        const response = await privateRequest.get(
            url,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error;
    }
};

export const fetchFreeFormByIdAPI = async (id: string) => {
    try {
        const response = await privateRequest.get(
            `${ENDPOINT.FREE_FORM}/${id}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log("response", response.data);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching question by ID:', error);
        throw error;
    }
};

export const createFreeFormAPI = async (data: any) => {
    try {
        const response = await privateRequest.post(
            ENDPOINT.FREE_FORM,
            data
        );

        return response.data;
    } catch (error) {
        console.error('Error creating question:', error);
        throw error;
    }
};

export const updateFreeFormAPI = async (data: any) => {
    try {
        const response = await privateRequest.post(
            `${ENDPOINT.FREE_FORM}`,
            data,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log(response);
        

        return response.data;
    } catch (error: any) {
        console.error("Error updating question:", error?.response || error);
        throw error;
    }
};

export const deleteFreeFormAPI = async (id: string) => {
    try {
        const response = await privateRequest.delete(
            `${ENDPOINT.FREE_FORM}/${id}`
        );

        toast.success(response?.data?.message || "Question deleted successfully");
        console.log(response.data);
        

        return response.data;
    } catch (error) {
        toast.error(error?.message || "Failed to delete question");
        console.error('Error deleting question:', error);
        throw error;
    }
};